import { waitForSpacesBetaOptIns } from '@/spaces/use/use-ask-pendo-artifact-add-to-space';

const BETA_OPT_IN_WAITERS = {
    spaces: waitForSpacesBetaOptIns,
};

export async function waitForRouteBetaOptIns (route) {
    await BETA_OPT_IN_WAITERS[route.meta.betaId]?.();
}
